export const V2_REPORT_ENGLISH = {
  "datox.v2.report.crumbs": "Report location",
  "datox.v2.report.state": "Review status",
  "datox.v2.report.historical": "Historical revision",
  "datox.v2.report.actions": "Report actions",
  "datox.v2.report.more": "More actions",
  "datox.v2.report.panel": "Beside the report",
  "datox.v2.report.panel.hide": "Hide the panel",
  "datox.v2.report.panel.show": "Show the panel",
  "datox.v2.report.tab.agent": "Agent",
  "datox.v2.report.tab.comments": "Comments",
  "datox.v2.report.agent.chats": "Conversations for this period",
  "datox.v2.report.agent.you": "You",
  "datox.v2.report.agent.agent": "Agent",
  "datox.v2.report.agent.empty": "No conversation for this period yet.",
  "datox.v2.report.agent.emptyHint": "Start a chat to ask the agent about this period’s data and reports.",
  "datox.v2.report.agent.noMessages": "This conversation has no saved messages yet.",
  "datox.v2.report.agent.continue": "Continue in chat",
  "datox.v2.report.agent.allChats": "All chats for this period",
  "datox.v2.report.agent.loadError": "Could not load the conversation.",
  "datox.v2.report.comments.empty": "No review comments yet.",
  "datox.v2.report.comments.hint": "Reviewers’ comments appear here once a review has been requested with Share.",
  "datox.v2.report.comments.error": "Could not load review comments.",
  "datox.v2.report.comments.noText": "No comment",
  "datox.v2.report.status.requested": "Pending",
  "datox.v2.report.status.approved": "Approved",
  "datox.v2.report.status.rejected": "Changes requested",
  "datox.v2.report.clients": "Reports in this period",
  "datox.v2.report.client.previous": "Previous report",
  "datox.v2.report.client.next": "Next report",
  "datox.v2.report.client.position": "{{index}}/{{total}}",
  "datox.v2.report.client.search": "Search clients and reports",
  "datox.v2.report.client.none": "No report matches",
  "datox.v2.report.zoom": "Zoom",
  "datox.v2.report.classic": "Open classic view",
  "datox.v2.report.classicHint": "This file type is previewed in the classic view.",
  "datox.v2.report.notFound": "This report is no longer available.",
  "datox.v2.report.back": "Back to reports & dashboards",
  "datox.v2.report.new": "New",
  "datox.v2.report.new.title": "New report",
  "datox.v2.report.new.close": "Close",
  "datox.v2.report.new.scratch": "Start from scratch",
  "datox.v2.report.new.scratchHint": "Describe the report you need. The agent drafts it page by page and you confirm each step.",
  "datox.v2.report.new.placeholder": "For example: a one-page factsheet for each client with performance, top holdings and sector allocation",
  "datox.v2.report.new.create": "Create with the agent",
  "datox.v2.report.new.notConnected": "Creating a report from a prompt or a blank page has no backend step yet. Use the Factsheet template to generate one.",
  "datox.v2.report.new.templates": "Start from a template",
  "datox.v2.report.new.templatesHint": "A template brings its layout and the agent’s instructions with it.",
  "datox.v2.report.new.templateHint": "Template in this project",
  "datox.v2.report.new.noTemplates": "No report templates in this project yet.",
  "datox.v2.report.new.open": "Open",
  "datox.v2.report.new.blank": "Blank report",
  "datox.v2.report.new.blankHint": "An empty page to compose block by block.",
  "datox.v2.report.new.use": "Use",
  "datox.v2.report.menu.delete": "Delete report",
  "datox.v2.report.agent.history": "History",
  "datox.v2.report.agent.newChat": "New chat",
  "datox.v2.report.agent.historyEmpty": "No saved conversations for this period.",
  "datox.v2.report.agent.ideasTitle": "What should we do with this report?",
  "datox.v2.report.agent.ideasTitleDashboard": "What should we do with this dashboard?",
  "datox.v2.report.agent.ideasHint": "Pick an idea or describe a change. The agent proposes it and you confirm.",
  "datox.v2.report.idea.analyze": "Summarise this report for the client in three sentences",
  "datox.v2.report.idea.modify": "Show the top 10 holdings instead of the top 5",
  "datox.v2.report.idea.create": "Add a page comparing sector allocation with last month",
  "datox.v2.report.idea.fix": "Find figures shown as N/A and explain why",
  "datox.v2.report.intent.pick": "Choose an intent",
  "datox.v2.report.intent.auto": "Auto",
  "datox.v2.report.intent.analyze": "Analyze",
  "datox.v2.report.intent.modify": "Modify",
  "datox.v2.report.intent.create": "Create",
  "datox.v2.report.intent.fix": "Fix",
  "datox.v2.report.intent.analyze.hint": "Explain data and compare values",
  "datox.v2.report.intent.modify.hint": "Change an existing block",
  "datox.v2.report.intent.create.hint": "Add blocks or pages",
  "datox.v2.report.intent.fix.hint": "Diagnose a problem and propose a repair",
  "datox.v2.report.composer.placeholder": "Ask about this page or request a change…",
  "datox.v2.report.composer.placeholderBlock": "Ask about “{{title}}” or request a change…",
  "datox.v2.report.composer.send": "Send",
  "datox.v2.report.composer.clearContext": "Clear the selection",
  "datox.v2.report.kind.header": "Header",
  "datox.v2.report.kind.kpi": "KPI",
  "datox.v2.report.kind.table": "Table",
  "datox.v2.report.kind.chart": "Chart",
  "datox.v2.report.kind.text": "Text",
  "datox.v2.report.kind.filter": "Filter",
  "datox.v2.report.dashboards": "Dashboards in this period",
  "datox.v2.report.notFoundDashboard": "This dashboard is no longer available.",
  "datox.v2.report.menu.publishedView": "Open published view",
  "datox.v2.report.menu.deleteDashboard": "Delete dashboard",
  "datox.v2.report.shareDashboardHint": "Opens the dashboard builder, where reviewers and client access are set. Nothing is sent from here.",
  "datox.v2.report.canvas.format": "Page format",
  "datox.v2.report.format.portrait": "A4 portrait",
  "datox.v2.report.format.landscape": "A4 landscape",
  "datox.v2.report.canvas.pageEdge": "A4 sheet {{index}}",
  "datox.v2.report.pages": "Pages",
  "datox.v2.report.pages.add": "Add page",
  "datox.v2.report.pages.rename": "Rename page",
  "datox.v2.report.pages.duplicate": "Duplicate page",
  "datox.v2.report.pages.delete": "Delete page",
  "datox.v2.report.status.bar": "Report status",
  "datox.v2.report.status.saved": "Saved",
  "datox.v2.report.status.rev": "Rev {{number}}",
  "datox.v2.report.status.revision": "Revision {{number}}",
  "datox.v2.report.status.blocks": "Blocks: {{count}}",
  "datox.v2.report.status.pages": "Page {{index}} of {{total}}",
  "datox.v2.report.status.page": "Page {{index}}",
  "datox.v2.report.inspector.data": "Data",
  "datox.v2.report.inspector.design": "Design",
  "datox.v2.report.inspector.none": "None",
  "datox.v2.report.inspector.source": "Source",
  "datox.v2.report.inspector.sourceValue": "Report document · {{revision}}",
  "datox.v2.report.inspector.latest": "latest revision",
  "datox.v2.report.inspector.sourceDashboard": "Dashboard · {{revision}}",
  "datox.v2.report.inspector.kind": "Type",
  "datox.v2.report.inspector.value": "Value",
  "datox.v2.report.inspector.rows": "Rows",
  "datox.v2.report.inspector.note": "Note",
  "datox.v2.report.inspector.columns": "Columns",
  "datox.v2.report.inspector.binding": "Data binding",
  "datox.v2.report.inspector.bindingValue": "Rendered document",
  "datox.v2.report.inspector.size": "Size",
  "datox.v2.report.inspector.sizeValue": "{{cols}} of 24 columns · {{height}} px high",
  "datox.v2.report.inspector.position": "Position",
  "datox.v2.report.inspector.positionValue": "x {{x}} · y {{y}} px",
  "datox.v2.report.inspector.background": "Background",
  "datox.v2.report.inspector.radius": "Corner radius",
  "datox.v2.report.inspector.border": "Border",
  "datox.v2.report.inspector.titleSize": "Title size",
  "datox.v2.report.review.none": "Review: not requested",
  "datox.v2.report.review.requested": "Review: pending",
  "datox.v2.report.review.approved": "Approved",
  "datox.v2.report.review.rejected": "Changes requested",
  "datox.v2.report.menu.downloadPDF": "Download PDF",
  "datox.v2.report.menu.format.html": "HTML",
  "datox.v2.report.menu.format.txt": "Text",
  "datox.v2.report.menu.format.json": "JSON",
  "datox.v2.report.menu.format.csv": "CSV",
  "datox.v2.report.menu.original": "Original file",
  "datox.v2.report.ideaDashboard.analyze": "Summarise this dashboard for the client in three sentences",
  "datox.v2.report.ideaDashboard.modify": "Show the top ten holdings instead of the top five",
  "datox.v2.report.ideaDashboard.create": "Add a widget comparing sector allocation with last month",
  "datox.v2.report.ideaDashboard.fix": "Find widgets with missing or empty data and explain why",
  "datox.v2.report.pages.note": "Page changes for reports aren’t saved yet.",
  "datox.v2.report.pages.noteDashboard": "Edit dashboard pages in the classic builder.",
  "datox.v2.report.new.back": "Back to templates",
  "datox.v2.report.new.factsheetHint": "Generate a factsheet report and dashboard from portfolio files",
  "datox.v2.report.dashboard.loadError": "Could not load the dashboard renderer. Refresh the page to try again.",
  "datox.v2.report.dock.blocks": "{{count}} blocks",
  "datox.v2.report.dock.meta": "{{kind}} · {{page}}",
  "datox.v2.report.dock.readOnly": "Read-only",
  "datox.v2.report.dock.state.missing": "N/A values: {{count}}",
  "datox.v2.report.dock.state.empty": "No data rows",
  "datox.v2.report.dock.state.unbound": "Not bound to a dataset",
  "datox.v2.report.dock.change": "Change this block",
  "datox.v2.report.dock.changeSeveral": "Change selected blocks",
  "datox.v2.report.dock.explainIssue.missing": "Explain the N/A values",
  "datox.v2.report.dock.explainIssue.empty": "Explain why it’s empty",
  "datox.v2.report.dock.explainIssue.unbound": "Explain what it needs",
  "datox.v2.report.dock.classic": "Edit in the classic builder",
  "datox.v2.report.dock.details.show": "Show details",
  "datox.v2.report.dock.details.hide": "Hide details",
  "datox.v2.report.dock.remove": "Remove {{title}} from the selection",
  "datox.v2.report.dock.cap": "Up to {{count}} blocks at a time.",
  "datox.v2.report.dock.strip.open": "View block details in the Agent tab ›",
  "datox.v2.report.composer.placeholderSeveral": "Ask about these {{count}} blocks or request a change…",
  "datox.v2.report.dock.viewing": "Viewing ·",
  "datox.v2.report.dock.more": "Block actions",
  "datox.v2.report.dock.showOnCanvas": "Show “{{title}}” on the canvas",
  "datox.v2.report.dock.details.showSeveral": "Show selected blocks",
  "datox.v2.report.dock.for": "For {{title}}",
  "datox.v2.report.dock.explainBlock": "Explain this block",
  "datox.v2.report.dock.explainTable": "Explain this table",
  "datox.v2.report.dock.explainSeveral": "Explain these {{count}} blocks",
  "datox.v2.report.suggest.calc": "Explain how this is calculated",
  "datox.v2.report.suggest.millions": "Show in {{unit}} millions",
  "datox.v2.report.suggest.millionsPlain": "Show in millions",
  "datox.v2.report.suggest.integer": "Round to a whole number",
  "datox.v2.report.suggest.oneDecimal": "Show one decimal place",
  "datox.v2.report.suggest.percent": "Show as a percent",
  "datox.v2.report.suggest.previous": "Compare with the previous period",
  "datox.v2.report.suggest.top": "Show top 10 instead of {{count}}",
  "datox.v2.report.suggest.sort": "Sort by {{column}}",
  "datox.v2.report.suggest.toTable": "Switch to a table",
  "datox.v2.report.suggest.outliers": "Explain the outliers",
  "datox.v2.report.suggest.shorten": "Shorten",
  "datox.v2.report.suggest.rewrite": "Rewrite for the client",
  "datox.v2.report.inspector.sourceColumn": "{{table}} table · column {{column}}",
  "datox.v2.report.inspector.sourceTable": "{{table}} table",
  "datox.v2.report.agent.working": "Working…",
  "datox.v2.report.agent.tool": "Running {{tool}}",
  "datox.v2.report.agent.step.starting": "Starting the agent…",
  "datox.v2.report.agent.step.readDashboard": "Reading the dashboard…",
  "datox.v2.report.agent.step.readReport": "Reading the report…",
  "datox.v2.report.agent.step.data": "Checking the data…",
  "datox.v2.report.agent.step.save": "Saving the revision…",
  "datox.v2.report.agent.step.instructions": "Reading the instructions…",
  "datox.v2.report.agent.step.prepare": "Preparing the change…",
  "datox.v2.report.agent.step.lookup": "Looking it up…",
  "datox.v2.report.agent.step.question": "Waiting for your answer…",
  "datox.v2.report.agent.step.writing": "Writing the reply…",
  "datox.v2.report.agent.elapsed": "{{seconds}}s",
  "datox.v2.report.agent.noReply": "The agent finished without a reply.",
  "datox.v2.report.agent.failed": "The agent couldn’t finish.",
  "datox.v2.report.agent.retry": "Retry",
  "datox.v2.report.agent.stop": "Stop",
  "datox.v2.report.agent.stopped": "Stopped. The agent may still finish in the chat.",
  "datox.v2.report.agent.noPeriod": "Open this from a period to ask the agent.",
  "datox.v2.report.agent.newRevision": "New revision {{number}} available",
  "datox.v2.report.agent.ask.question": "The agent asks",
  "datox.v2.report.agent.ask.permission": "The agent asks for permission",
  "datox.v2.report.agent.ask.allow": "Allow",
  "datox.v2.report.agent.ask.deny": "Deny",
  "datox.v2.report.agent.ask.dismiss": "Dismiss",
  "datox.v2.report.agent.ask.submit": "Send answer",
  "datox.v2.report.agent.ask.failed": "Couldn’t send the answer. Try again.",
  "datox.v2.report.result.label": "What this reply changed",
  "datox.v2.report.result.saved": "Revision {{number}} saved",
  "datox.v2.report.result.loading": "Comparing with revision {{number}}…",
  "datox.v2.report.result.show": "Show on canvas",
  "datox.v2.report.result.showBlock": "Show this block on the canvas",
  "datox.v2.report.result.open": "Open revision {{number}}",
  "datox.v2.report.result.none": "No block changed; only the dashboard’s settings did.",
  "datox.v2.report.result.added": "Added as {{type}}",
  "datox.v2.report.result.removed": "Removed",
  "datox.v2.report.result.retyped": "Changed from {{from}} to {{to}}",
  "datox.v2.report.result.retitled": "Renamed from “{{title}}”",
  "datox.v2.report.result.rebound": "Reads different data",
  "datox.v2.report.result.edited": "Content or format changed",
  // §44: the V2 revision picker and the earlier-version banner.
  "datox.v2.revisions.title": "Versions",
  "datox.v2.revisions.today": "Today {{time}}",
  "datox.v2.revisions.latest": "Latest",
  "datox.v2.revisions.incomplete": "Incomplete",
  "datox.v2.revisions.option": "Revision {{number}}, {{date}}",
  "datox.v2.revisions.empty": "No earlier versions yet",
  "datox.v2.revisions.earlier": "Viewing an earlier version. It is read only.",
  "datox.v2.editor.clientCount.one": "{{count}} client",
  "datox.v2.editor.clientCount.other": "{{count}} clients",
  "datox.v2.history.archiveConfirm": "Archive “{{name}}”? It leaves the reports list, with all its client sheets. Source files and conversations are kept. An archived report can't be restored from the app yet.",
  "datox.v2.history.archiving": "Archiving…",
  "datox.v2.history.exportLine": "Version {{version}} · {{date}}",
  "datox.v2.history.runFailed": "This run stopped before it finished.",
  "datox.v2.workflow.runs.allCount": "All {{count}} runs",
  "datox.v2.workflow.runs.fewer": "Show the last 5",
} as const
